/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IExampleParent } from '../../../core/models/common/IExampleParent';
import { Schema } from '../../../core/models/common/Schema';
import { OasParameter } from '../../models/OasParameter';

/**
 * Constructor.
 * @param {string} named
 * @class
 * @extends OasParameter
 * @author eric.wittmann@gmail.com
 */
export class Oas30Parameter extends OasParameter implements IOas30MediaTypeParent, IExampleParent {
    public deprecated : boolean;

    public style : string;

    public explode : boolean;

    public allowReserved : boolean;

    public example : any;

    public examples : any;

    public content : any;

    public constructor(named? : any) {
        if(((typeof named === 'string') || named === null)) {
            let __args = arguments;
            super(named);
            if(this.deprecated===undefined) this.deprecated = null;
            if(this.style===undefined) this.style = null;
            if(this.explode===undefined) this.explode = null;
            if(this.allowReserved===undefined) this.allowReserved = null;
            if(this.example===undefined) this.example = null;
            this.examples = <any>({});
            this.content = <any>({});
            if(this.deprecated===undefined) this.deprecated = null;
            if(this.style===undefined) this.style = null;
            if(this.explode===undefined) this.explode = null;
            if(this.allowReserved===undefined) this.allowReserved = null;
            if(this.example===undefined) this.example = null;
        } else if(named === undefined) {
            let __args = arguments;
            super();
            if(this.deprecated===undefined) this.deprecated = null;
            if(this.style===undefined) this.style = null;
            if(this.explode===undefined) this.explode = null;
            if(this.allowReserved===undefined) this.allowReserved = null;
            if(this.example===undefined) this.example = null;
            this.examples = <any>({});
            this.content = <any>({});
            if(this.deprecated===undefined) this.deprecated = null;
            if(this.style===undefined) this.style = null;
            if(this.explode===undefined) this.explode = null;
            if(this.allowReserved===undefined) this.allowReserved = null;
            if(this.example===undefined) this.example = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Parameter#createSchema()
     * @return {Schema}
     */
    public createSchema() : Schema {
        let schema : Schema = new Oas30Schema();
        schema._ownerDocument = this.ownerDocument();
        schema._parent = this;
        return schema;
    }

    /**
     * Creates a child Example model.
     * @param {string} name
     * @return {Oas30Example}
     */
    public createExample(name : string) : Oas30Example {
        let rval : Oas30Example = new Oas30Example(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds the Example to the map of examples.
     * @param {Oas30Example} example
     */
    public addExample(example : Oas30Example) {
        /* put */(this.examples[example.getName()] = example);
    }

    /**
     * Removes an Example and returns it.
     * @param {string} name
     * @return {Oas30Example}
     */
    public removeExample(name : string) : Oas30Example {
        return /* remove */(map => { let deleted = this.examples[name];delete this.examples[name];return deleted;})(this.examples);
    }

    /**
     * Gets a single example by name.
     * @param {string} name
     * @return {Oas30Example}
     */
    public getExample(name : string) : Oas30Example {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.examples, name);
    }

    /**
     * Gets all examples.
     * @return {Oas30Example[]}
     */
    public getExamples() : Array<Oas30Example> {
        let rval : Array<Oas30Example> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.examples));
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#createMediaType(java.lang.String)
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public createMediaType(name : string) : Oas30MediaType {
        let rval : Oas30MediaType = new Oas30MediaType(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#addMediaType(java.lang.String, io.apicurio.datamodels.openapi.v3.models.Oas30MediaType)
     * @param {string} name
     * @param {Oas30MediaType} mediaType
     */
    public addMediaType(name : string, mediaType : Oas30MediaType) {
        /* put */(this.content[name] = mediaType);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#getMediaType(java.lang.String)
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public getMediaType(name : string) : Oas30MediaType {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.content, name);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#removeMediaType(java.lang.String)
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public removeMediaType(name : string) : Oas30MediaType {
        return /* remove */(map => { let deleted = this.content[name];delete this.content[name];return deleted;})(this.content);
    }

    /**
     * @see io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent#getMediaTypes()
     * @return {Oas30MediaType[]}
     */
    public getMediaTypes() : Array<Oas30MediaType> {
        let rval : Array<Oas30MediaType> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.content));
        return rval;
    }
}
Oas30Parameter["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Parameter";
Oas30Parameter["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IExampleParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.openapi.v3.models.IOas30MediaTypeParent","io.apicurio.datamodels.core.models.common.INamed"];





import { Oas30Schema } from './Oas30Schema';


import { Oas30MediaType } from './Oas30MediaType';


import { Oas30Example } from './Oas30Example';


import { IOas30MediaTypeParent } from './IOas30MediaTypeParent';

